const attributes = [
    {
        isHeader: true,
        name: 'friendlyName',
        sortable: true,
        sortBy: 'friendlyName',
        label: 'ViewRequest',
        headerCellStyles: {
            width: '15%',
            minWidth: '130px',
        },
        styles: {
            color: '#9230c5',
            fontSize: '16px',
            fontWeight: 'bold',
            marginTop: '6px',
            marginLeft: '10px',
            '&:hover': {
                textDecoration: 'underline',
            },
        },
        link: false,
    },
    {
        name: 'number',
        label: 'RequestNo',
        sortBy: 'number',
        avatar: false,
        sortable: true,
        headerCellStyles: {
            minWidth: '11rem',
        },
        styles: {
            marginTop: '6px',
            fontSize: '13px',
            whiteSpace: 'normal',
            color: '#282828',
        },
    },
    {
        name: 'percentageCompleted',
        label: 'PercentageComplete',
        sortBy: 'percentageCompleted',
        avatar: false,
        sortable: true,
        hideValue: true,
        headerCellStyles: {
            minWidth: '12.5rem',
        },
        styles: {
            marginTop: '6px',
            fontSize: '13px',
            whiteSpace: 'normal',
            color: '#282828',
        },
        component: {
            componentName: 'Percentage',
        },
    },
    {
        name: 'businessRequestStatusFriendlyName',
        hideValue: true,
        label: 'BusinessRequestStatus',
        sortable: true,
        sortBy: 'businessRequestStatusFriendlyName',

        headerCellStyles: {
            width: '15%',
            minWidth: '15%',
        },
        styles: {
            padding: '20px 0px',
        },
        component: {
            componentName: 'StatusIndicator',
            name: 'businessRequestStatusFriendlyName',
            props: {
                size: 'medium',
            },
        },
    },

    {
        name: 'initiatorPersonFriendlyName',
        label: 'Initiator',
        hideValue: true,
        sortable: true,
        sortBy: 'initiatorPersonFriendlyName',
        avatar: true,
        // imgProp: 'approverPersonURL',
        headerCellStyles: {
            maxWidth: '20rem',
        },
        styles: {
            maxWidth: '20rem',
        },
        textStyles: {
            color: '#282828',
            fontSize: '13px',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            wordBreak: 'break-word',
        },
    },
    {
        name: 'subjectTypeFriendlyName',
        label: 'SubjectType',
        sortBy: 'subjectTypeFriendlyName',
        avatar: false,
        sortable: true,
        headerCellStyles: {
            maxWidth: '150px',
        },
        styles: {
            maxWidth: '150px',
            marginTop: '6px',
            fontSize: '13px',
            whiteSpace: 'normal',
            color: '#282828',
        },
    },
    {
        name: 'requestDataTargetResourceFriendlyName',
        label: 'SubjectOfRequest',
        hideValue: true,
        sortable: true,
        sortBy: 'requestDataTargetResourceFriendlyName',
        avatar: true,
        // imgProp: 'approverPersonURL',
        headerCellStyles: {
            maxWidth: '150px',
        },
        styles: {
            maxWidth: '150px',
        },
        textStyles: {
            color: '#282828',
            fontSize: '13px',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            wordBreak: 'break-word',
        },
    },
    {
        name: 'inactivityExpirationDateUtc',
        hideValue: true,
        label: 'ExpirationDate',
        sortable: true,
        sortBy: 'inactivityExpirationDateUtc',

        headerCellStyles: {
            width: '15%',
            minWidth: '15%',
        },
        component: { componentName: 'CellDateTime' },
    },

    {
        name: 'riskLevel',
        hideValue: true,
        label: 'RiskLevel',
        sortable: true,
        sortBy: 'riskLevel',
        headerCellStyles: {
            width: '10%',
            maxWidth: '105px',
        },
        styles: {
            maxWidth: '105px',
        },
        component: { componentName: 'RiskIndicator', name: 'riskLevel' },
    },
    {
        hideValue: true,

        button: { name: 'ShowHideButton' },
    },
]
export const expandedAttributes = () => [
    // Row 1 Starts
    [
        {
            label: 'CreatedDate',
            name: 'createdDateUtc',
            component: {
                componentName: 'CellDateTime',
            },
        },
        {
            label: 'ExternalRequestID',
            name: 'externalRequestID',
        },
        {
            label: 'ExpiresAfterXDays',
            name: 'expireRequestAfterXDaysOfInactivity',
        },
        {
            label: 'NeededBy',
            name: 'dueDateUtc',
            component: {
                componentName: 'CellDateTime',
            },
        },
        {
            label: 'FinalDecisionDate',
            name: 'finalDecisionDateUtc',
            component: {
                componentName: 'CellDateTime',
            },
        },
        {
            label: 'InactivityExpirationDate',
            name: 'inactivityExpirationDateUtc',
            component: {
                componentName: 'CellDateTime',
            },
        },
    ],
    // Row 2 Starts
    [
        {
            label: 'BusinessRequestType',
            name: 'typeFriendlyName',
        },
        {
            label: 'RiskCompilationDate',
            name: 'riskCompilationDateUtc',
            component: {
                componentName: 'CellDateTime',
            },
        },
        {
            label: 'HighestRiskLevel',
            name: 'riskLevel',
            component: {
                componentName: 'RiskIndicator',
            },
        },
        {
            label: 'TotalCompiledRiskRuleViolations',
            name: 'riskCount',
        },
        {
            label: 'TotalRiskScore',
            name: 'riskScoreTotal',
        },
        {
            label: 'InitiatorComments',
            name: 'initiatorComments',
        },
    ],
    // Row 3 Starts
    [
        {
            label: 'ProcessTime',
            name: 'processTimeUtc',
            component: {
                componentName: 'CellDateTime',
            },
        },
        {
            label: 'LockedByServer',
            name: 'lockedByServer',
            component: {
                componentName: 'Boolean',
            },
        },
        {
            label: 'ReclaimByDate',
            name: 'reclaimByDateUtc',
            component: {
                componentName: 'CellDateTime',
            },
        },
        {
            label: 'LastFailed',
            name: 'lastFailedUtc',
            component: {
                componentName: 'CellDateTime',
            },
        },
        {
            label: 'LastError',
            name: 'lastFailedError',
            component: {
                componentName: 'CellDateTime',
            },
        },
        {
            label: 'NextAttempt',
            name: 'nextAttemptUtc',
            component: {
                componentName: 'CellDateTime',
            },
        },
    ],
    // Row 4 Starts
    [
        {
            label: 'FailedCount',
            name: 'failedCount',
        },
        {
            label: 'PreStepProcessTime',
            name: 'preStepProcessTimeUtc',
            component: {
                componentName: 'CellDateTime',
            },
        },
        {
            label: 'PreStepFailedCount',
            name: 'preStepFailedCount',
        },
        {
            label: 'PreStepLastFailed',
            name: 'preStepLastFailedUtc',
            component: {
                componentName: 'CellDateTime',
            },
        },
        {
            label: 'PreStepLastFailedError',
            name: 'preStepLastFailedError',
            component: {
                componentName: 'CellDateTime',
            },
        },
        {
            label: 'ExternalProcessStep',
            name: 'externalProcessStatus',
            component: {
                componentName: 'StatusIndicator',
                props: {
                    size: 'medium',
                },
            },
        },
    ],
]
export default attributes
